// src/components/auth/AuthGuard.tsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { PATHS } from "./paths";

export const AuthGuard: React.FC = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);


  if (!isAuthenticated) {
    return <Navigate to={PATHS.AUTH_SIGN_IN} replace />;
  }

  return <Outlet />;
};